import React from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { useAuth } from '../../providers/Auth';
import { UserRoles } from '../../constants/bindings';

const PrivateRoute = ({ component: Component, bindings, ...rest }) => {
  const location = useLocation();
  const user = useAuth();
  let role = user.user ? user.user.attributes['custom:custom.roles'] : null;
  if(role && role.includes(',')) { 
    let removeBrackets = role.substring(1,role.length-1);
    const uniqueRoles = removeBrackets.split(', ');
    role = uniqueRoles.map(r => {return r});
  } else {
    role = [role];
  }

  const handleRedirect = () => {
    if (role.includes(UserRoles.ADMIN)) {
      return false;
    }
    const shouldRedirect =  bindings.some(b => role.includes(b));
    return !shouldRedirect;
  }


  return (
    <Route {...rest} render={props => {
      if (!user.loading ) {
        
        if(!user.user) {
          return <Redirect to={{ pathname: '/', state: { from: location } }} />;
        }
        else if (handleRedirect()) {
          return <Redirect to={{ pathname: '/'}} />;
        }
        
      }
      
      return <Component {...props} />;
   }}/>    
  );
};

export default PrivateRoute;
